import { ILandingPageComponentListingQuery } from '../interfaces/landing-page-component-listing.query.interface';
import { UserExtendedAttributeWithValue } from 'app/projects/user/src/lib/models/user-attribute-with-value';
import { LandingPageComponentBookedExecution } from './landing-page-component-booked-execution.model';
import { LandingPageComponentListingEventsPreview } from './landing-page-component-listing-events-preview.model';
import { MaxbrainImage } from 'app/library/image-library/models/maxbrain-image.model';
import { IModuleDuration } from 'app/library/module/interfaces/module-duration.interface';
import { ModuleUserProgressStatus } from 'app/library/module-user/enums/module-user-progress-status.enum';
import { LandingPageComponentPermission } from './landing-page-component-permission.model';

export class LandingPageComponentListing {
    id: string;
    name: string;
    startDate: string | null;
    endDate: string | null;
    duration: IModuleDuration | null;
    image: MaxbrainImage | null;
    contentType: { id: number; name: string; displayNameKeySingular: string } | null;
    listingType: number;
    price: { amount: number | null; currency: string } | null;
    previousPrice: { amount: number; currency: string } | null;
    registrationSettings: {
        registrationEndDate: string | null;
        visibility: string | null;
        registrationStatus: string;
        courseStatus: string;
        openSpots: number | null;
    } | null;
    attributes: UserExtendedAttributeWithValue[] = [];
    bookingRequestId: string | null;
    bookingRequestStatus: string | null;
    bookingRequestCount: number;
    bookingProgressStatus: ModuleUserProgressStatus | null;
    bookedExecution: LandingPageComponentBookedExecution | null;
    eventsPreview: LandingPageComponentListingEventsPreview | null;
    permissions: LandingPageComponentPermission[] = [];
    requiresApproval: boolean;

    constructor(query: ILandingPageComponentListingQuery) {
        this.id = query.id.toString();
        this.name = query.name;
        this.startDate = query.start_date ?? null;
        this.endDate = query.end_date ?? null;
        this.duration = this._mapDuration(query.duration);
        this.image = query.image ? new MaxbrainImage(query.image) : null;
        this.contentType = query.content_type
            ? {
                  id: query.content_type.id,
                  name: query.content_type.name,
                  displayNameKeySingular: query.content_type.display_name_key_singular,
              }
            : null;
        this.listingType = query.listing_type;
        this.price = query.price;
        this.previousPrice = query.previous_price;
        this.registrationSettings = query.registration_settings
            ? {
                  registrationEndDate: query.registration_settings.registration_end_date,
                  visibility: query.registration_settings.visibility ?? null,
                  registrationStatus: query.registration_settings.registration_status,
                  courseStatus: query.registration_settings.course_status,
                  openSpots: query.registration_settings.open_spots,
              }
            : null;
        this.attributes = (query.attributes || []).map((attributeWithValue) => new UserExtendedAttributeWithValue(attributeWithValue.attribute, attributeWithValue.value));
        this.bookingRequestId = query.booking_request_id !== null && query.booking_request_id !== undefined ? query.booking_request_id.toString() : null;
        this.bookingRequestStatus = query.booking_request_status ?? null;
        this.bookingRequestCount = query.booking_request_count ?? 0;
        this.bookingProgressStatus = query.booking_progress_status ?? null;
        this.bookedExecution = query.booked_execution ? new LandingPageComponentBookedExecution(query.booked_execution) : null;
        this.eventsPreview = query.events_preview ? new LandingPageComponentListingEventsPreview(query.events_preview) : null;
        this.permissions = (query.permissions || []).map((permission) => new LandingPageComponentPermission(permission));
        this.requiresApproval = query.requires_approval;
    }

    private _mapDuration(duration: IModuleDuration | null | undefined): IModuleDuration | null {
        if (!duration) {
            return null;
        }

        let hasValue = false;
        for (const property in duration) {
            if (duration[property as keyof IModuleDuration]) {
                hasValue = true;
                break;
            }
        }

        return hasValue ? duration : null;
    }
}
